"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _NavigationBlock = _interopRequireDefault(require("./NavigationBlock"));

var _utils = require("../utils");

var _NavigationLink = _interopRequireDefault(require("./NavigationLink"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CategoriesSideBarNavigation = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CategoriesSideBarNavigation, _Component);

  var _super = _createSuper(CategoriesSideBarNavigation);

  function CategoriesSideBarNavigation() {
    var _this;

    (0, _classCallCheck2.default)(this, CategoriesSideBarNavigation);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      expandedCategories: (0, _toConsumableArray2.default)(new Set((0, _utils.pathToGivenCategory)(_this.props.categories, _this.props.currentCategory)))
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleCategory", function (categoryId) {
      _this.setState(function (prevState) {
        var expandedCategoryIds = new Set(prevState.expandedCategories);

        if (expandedCategoryIds.has(categoryId)) {
          expandedCategoryIds.delete(categoryId);
          return {
            expandedCategories: Array.from(expandedCategoryIds)
          };
        }

        expandedCategoryIds.add(categoryId);
        return {
          expandedCategories: Array.from(expandedCategoryIds)
        };
      });
    });
    return _this;
  }

  (0, _createClass2.default)(CategoriesSideBarNavigation, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          currentCategory = _this$props.currentCategory,
          categories = _this$props.categories;
      var expandedCategories = this.state.expandedCategories;
      var pathToCategory = (0, _utils.pathToGivenCategory)(categories, currentCategory);
      return (0, _preact.h)("div", {
        className: "category-sidebar-navigation"
      }, categories.map(function (category) {
        var categoryId = category.id,
            title = category.title,
            children = category.children,
            url = category.url;
        var isCurrent = currentCategory === categoryId;
        var isExpanded = expandedCategories.includes(categoryId);
        var hasChildren = Boolean(children.length);
        return (0, _preact.h)("div", {
          className: "category-sidebar-navigation__parent-wrapper",
          key: "category-id-".concat(categoryId)
        }, (0, _preact.h)("div", {
          className: "category-sidebar-navigation__header"
        }, (0, _preact.h)(_NavigationLink.default, {
          url: url,
          isCurrent: isCurrent,
          topLevel: true,
          toggleCategory: _this2.toggleCategory,
          categoryId: categoryId,
          isExpanded: isExpanded,
          hasChildren: hasChildren
        }, title)), hasChildren && expandedCategories.includes(categoryId) && (0, _preact.h)(_NavigationBlock.default, {
          categories: children,
          currentCategory: currentCategory,
          pathToCategory: pathToCategory,
          showBorder: true,
          expandedCategories: expandedCategories,
          toggleCategory: _this2.toggleCategory
        }));
      }));
    }
  }]);
  return CategoriesSideBarNavigation;
}(_preact.Component);

var _default = CategoriesSideBarNavigation;
exports.default = _default;